import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=eff5b34e&scoped=true"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=eff5b34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff5b34e",
  null
  
)

export default component.exports